// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertFilledSvg from "@fishx/icons-svg/es/asn/AlertFilled";
import FishxIcon from '../components/FishxIcon';

var AlertFilled = function AlertFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertFilledSvg
  }));
};

AlertFilled.displayName = 'AlertFilled';
export default React.forwardRef(AlertFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlertFilled.js
// module id = 1952
// module chunks = 0